import { render, staticRenderFns } from "./schoolbus.vue?vue&type=template&id=afc62b00&"
import script from "./schoolbus.vue?vue&type=script&lang=js&"
export * from "./schoolbus.vue?vue&type=script&lang=js&"
import style0 from "./schoolbus.vue?vue&type=style&index=0&id=afc62b00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports